<template>
  <table class="table-auto w-full border-collapse">
    <thead>
      <tr class="text-gray-500">
        <th>코인</th>

        <th></th>
        <th>매수 설정(%)</th>
        <th>
          매도 설정(%)<button
            type="button"
            class="tooltip pl-1"
            @click="openHelpModal('profit')"
          >
            &#9432;
          </button>
        </th>
        <th>
          매수 중지(%)<button
            type="button"
            class="tooltip pl-1"
            @click="openHelpModal('stop')"
          >
            &#9432;
          </button>
        </th>
        <th>
          강제 매도(%)<button
            type="button"
            class="tooltip pl-1"
            @click="openHelpModal('force')"
          >
            &#9432;
          </button>
        </th>
        <th>현재가</th>
        <th>청산가</th>
        <th>총 매수금액</th>
        <th>평균 매수가</th>
        <th>
          수익<button
            type="button"
            class="tooltip pl-1"
            @click="openHelpModal('unpl')"
          >
            &#9432;
          </button>
        </th>
        <th>누적 수익</th>
      </tr>
    </thead>
    <tbody>
      <CoinRow
        v-for="coin in coins"
        :key="coin.id"
        :coin="coin"
        :buyConfig="getBuyConfig(coin.name)"
        :manualControl="getSymbolManualControl(coin.name, GT_IS_LONG)"
        :cumulativeP="getCumulativeP(coin.name)"
        @modifyTrigger="openModifyModal"
        @action="onAction"
        @modal-open="openModal"
      />
    </tbody>
  </table>
  <!-- 매수 설정 모달을 해당 영역에 위치함 (25.2.21 수정)-->
  <ModalPopup
    v-if="isBuyModalOpen"
    :coinName="modal.symbol"
    :buyConfig="getBuyConfig(modal.symbol)"
    :updatable="getIsUpdateable(modal.symbol)"
    @modal-close="closeModal"
  />
  <!-- 레버리지 변경 모달을 해당 영역에 위치함 (25.2.21 수정)-->
  <LeverageModal
    v-if="isLvgModalOpen"
    :coinName="modal.symbol"
    @modal-close="closeModal"
  />
  <MarginTypeModal
    v-if="isMtModalOpen"
    :coinName="modal.symbol"
    @modal-close="closeModal"
  />
  <ColumnHelpModal
    v-if="helpModal.open"
    :colType="helpModal.type"
    @modal-close="closeHelpModal"
  />
  <TpslModifyModal
    v-if="modifyModal.open"
    :tpslType="modifyModal.type"
    :buyConfig="getBuyConfig(modifyModal.symbol)"
    @modal-close="closeModifyModal"
  />
</template>

<script>
import { mapActions, mapGetters, mapMutations } from "vuex";
import CoinRow from "./CoinRow.vue";
import { serviceCoinList, storeName } from "@/global/variable";
import LeverageModal from "./modal/LeverageModal.vue";
import ModalPopup from "./modal/ModalPopup.vue";
import MarginTypeModal from "./modal/MarginTypeModal.vue";
import ColumnHelpModal from "./modal/ColumnHelpModal.vue";
import TpslModifyModal from "./modal/TpslModifyModal.vue";

export default {
  components: {
    CoinRow,
    LeverageModal,
    MarginTypeModal,
    ModalPopup,
    ColumnHelpModal,
    TpslModifyModal,
  },
  data() {
    return {
      coins: serviceCoinList,
      modal: {
        open: false,
        type: null, // lvg(레버리지 모달) , buy(매수 모달)
        symbol: null,
      },
      helpModal: {
        open: false,
        type: "",
      },
      modifyModal: {
        open: false,
        type: "",
        symbol: null,
      },
    };
  },
  mounted() {
    // TODO : 심볼별 양방향 강제 매수 중지, 강제 매도 설정 데이터 조회
    this.$store.dispatch(`${storeName.stop}/AT_LOAD_STOP_ALL`);
    this.$store.dispatch(`${storeName.stop}/AT_LOAD_SELL_ALL`);
    this.$store.dispatch(`${storeName.manual}/AT_GET_MANUAL`);
    this.$store.dispatch(`${storeName.buyConfig}/AC_GET_ALL_CONFIGS`);
  },
  computed: {
    ...mapGetters(storeName.core, ["GT_IS_LONG", "GT_POSITION_TYPE"]),

    ...mapGetters(storeName.buy, ["BUY_STEPS", "SELL_STEPS"]),
    ...mapGetters(storeName.manual, ["GT_LONG_MANUAL", "GT_SHORT_MANUAL"]),
    ...mapGetters(storeName.buyConfig, [
      "GT_LONG_BUY_CONFIGS",
      "GT_SHORT_BUY_CONFIGS",
    ]),
    ...mapGetters(storeName.tradeHistory, ["GT_CUM_LONG", "GT_CUM_SHORT"]),

    isLvgModalOpen: function () {
      return (
        this.modal.open &&
        this.modal.type === "lvg" &&
        this.modal.symbol != null
      );
    },
    isBuyModalOpen: function () {
      return (
        this.modal.open &&
        this.modal.type === "buy" &&
        this.modal.symbol != null
      );
    },
    isMtModalOpen: function () {
      return (
        this.modal.open && this.modal.type === "mt" && this.modal.symbol != null
      );
    },
  },
  methods: {
    ...mapActions(storeName.buy, ["AT_CLOSE_POSITION", "AT_CANCEL_POSITION"]),
    ...mapMutations(storeName.manual, ["MU_UPDATE_M_SINGLE"]),
    ...mapActions(storeName.manual, ["AT_GET_MANUAL"]),
    ...mapActions(storeName.buyConfig, [
      "AC_EXEC_BUY_CONFIG",
      "AC_EXEC_BUY_STOP",
      "AC_GET_CONFIG",
    ]),

    /**
     * 모달 오픈
     * @param modalType {String} lvg | buy
     * @param symbol {String} [format : "symbolName" + "USDT"]
     */
    openModal(modalType, symbol) {
      if (modalType === "lvg" || modalType === "mt") {
        // long, short 포지션 모두 중지 혹은 매도 후 거래 가능
        console.log(this.GT_LONG_MANUAL[symbol]);
        console.log(this.GT_SHORT_MANUAL[symbol]);
        const longManualBoolean = this.GT_LONG_MANUAL[symbol] == 1;
        const longConfig = this.GT_LONG_BUY_CONFIGS[symbol].config;
        const shortManualBoolean = this.GT_SHORT_MANUAL[symbol] == 1;
        const shortConfig = this.GT_SHORT_BUY_CONFIGS[symbol].config;
        const longConfigClosed = longConfig ? longConfig.isEndTrade : true;
        const shortConfigClosed = shortConfig ? shortConfig.isEndTrade : true;

        if (longManualBoolean || longConfigClosed) {
          true;
        }
        if (shortManualBoolean || shortConfigClosed) {
          true;
        }

        if (
          (!longManualBoolean && !longConfigClosed) ||
          (!shortManualBoolean && !shortConfigClosed)
        ) {
          alert(
            `${symbol} 레버리지 변경은 해당 코인의 LONG, SHORT 포지션 모두 '매수중지' 하거나 '포지션 종료(매도)' 후 가능합니다.'`
          );
          return false;
        }
      }
      this.modal = {
        open: true,
        type: modalType,
        symbol: symbol,
      };
    },
    /**
     * 모달 종료
     */
    closeModal() {
      this.modal = {
        open: false,
        type: null,
        symbol: null,
      };
    },
    openHelpModal(colType) {
      this.helpModal = {
        open: true,
        type: colType,
      };
    },
    closeHelpModal() {
      this.helpModal = {
        open: false,
        type: "",
      };
    },
    openModifyModal(type, symbol) {
      this.modifyModal = {
        open: true,
        type: type,
        symbol: symbol,
      };
    },
    closeModifyModal() {
      this.modifyModal = {
        open: false,
        type: "",
        symbol: null,
      };
    },

    // CoinRow.vue의 버튼 클릭 이벤트 확인
    async onAction(action, coinId, position, symbol) {
      switch (action) {
        case "start":
          // 거래 시작
          if (!confirm("저장된 값으로 거래를 진행하시겠습니까?")) return;
          var { result, updateResultType } = await this.AC_EXEC_BUY_CONFIG({
            symbol: symbol,
            position: position,
            tradeConfigId: coinId,
          });
          console.log(result);
          this.AT_GET_MANUAL();
          if (updateResultType === "buyStopChange") {
            await this.AC_GET_CONFIG({ symbol: symbol, position: position });
          }

          break;
        case "stop":
          // 중지
          if (!confirm("해당 포지션 거래를 중지하시겠습니까?")) return false;

          await this.AC_EXEC_BUY_STOP({
            symbol: symbol,
            position: position,
            tradeConfigId: coinId,
          });
          this.AC_GET_CONFIG({
            symbol: symbol,
            position: position.toUpperCase(),
          });
          this.AT_GET_MANUAL();
          break;
        case "sell":
          // 손/익절
          // 포지션 청산에 해당됨.
          if (!confirm("해당 포지션을 청산하시겠습니까?")) return false;

          // 특정 코인에 포지션 청산 요청
          await this.AT_CLOSE_POSITION({
            position,
            symbol,
            coinId,
          });
          this.AT_GET_MANUAL();
          // if (buyStopFlag.buyStop) {
          //   // 사용자 수동 거래 중지
          //   // TODO : 매뉴얼 mutation 업데이트
          //   this.MU_UPDATE_M_SINGLE({
          //     position: position.toLowerCase(),
          //     symbol: symbol.toUpperCase(),
          //     isStop: buyStopFlag.buyStop,
          //   });
          // } else {
          //   // 사용자 수동 거래 중지 하지않음.
          //   // TODO : 매뉴얼 mutation 업데이트
          //   this.MU_UPDATE_M_SINGLE({
          //     position: position.toLowerCase(),
          //     symbol: symbol.toUpperCase(),
          //     isStop: false,
          //   });
          // }

          break;
      }
    },
    /**
     * 거래 ,중지 버튼 활성화 여부 확인
     * @param symbol
     * @param isLong
     */
    getSymbolManualControl(symbol, isLong) {
      if (isLong) {
        return this.GT_LONG_MANUAL[symbol + "USDT"];
      } else {
        return this.GT_SHORT_MANUAL[symbol + "USDT"];
      }
    },

    /**
     * 포지션,코인별 매수 설정 조회
     * @param symbol {string} format( btc, eth ... ) ; non usdt
     */
    getBuyConfig(symbol) {
      const _symbolName = symbol.includes("USDT") ? symbol : symbol + "USDT";

      if (this.GT_IS_LONG) {
        return this.GT_LONG_BUY_CONFIGS[_symbolName];
      } else {
        return this.GT_SHORT_BUY_CONFIGS[_symbolName];
      }
    },

    getCumulativeP(symbol) {
      const target = this.GT_IS_LONG ? this.GT_CUM_LONG : this.GT_CUM_SHORT;

      return target.find((f) => f.symbol === symbol + "USDT");
    },

    getIsUpdateable(coinName) {
      // 포지션이 거래 중지 상태이거나, 포지션이 없는 경우에 수정 할 수 있음.
      let manual;
      let config;
      let configBoolean;
      if (this.GT_IS_LONG) {
        manual = this.GT_LONG_MANUAL[coinName];
        config = this.GT_LONG_BUY_CONFIGS[coinName];
      } else {
        manual = this.GT_SHORT_MANUAL[coinName];
        config = this.GT_SHORT_BUY_CONFIGS[coinName];
      }
      if (config.config == null) {
        configBoolean = true;
      } else {
        configBoolean = config.config.isEndTrade;
      }
      return manual == 1 || configBoolean;
    },
  },
};
</script>
